export enum SelectedVariablesSortEnum {
  selectionOrder = 'by Selection Order',
  alphabetically = 'Alphabetically',
}